import { useMemo } from 'react';
import { IGroup } from '@nkr/models/index';
import { AgGridReact } from 'ag-grid-react';
import { GridWrapper } from './styles';
import { FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { Button, Glyphicon } from 'react-bootstrap';
import SortableHeaderComponent from '../admin/center/list/common/sortable-header';

interface IProps {
    data: IGroup[],
    onEdit: (id: number) => void
}

const GroupGrid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        // this.setState({
        //     gridApi: e.api,
        //     columnApi: e.columnApi
        // });

        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const columns = [
        {
            colId: 'name',
            field: 'name',
            headerName: 'Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Name</SortableHeaderComponent>,
            width: 200
        },

        {
            colId: 'description',
            field: 'description',
            headerName: 'Description',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Description</SortableHeaderComponent>,
            width: 175
        },

        {
            colId: 'isSuperAdmin',
            field: 'isSuper',
            headerName: 'Super Admin',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Super<br />Admin</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'manageUsers',
            field: 'manageUsers',
            headerName: 'Manage Users',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Manage<br />Users</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'useCP',
            field: 'useCP',
            headerName: 'Use CP',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Use CP</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'accessTicketing',
            field: 'accessTicketing',
            headerName: 'Access Ticketing',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Access<br />Ticketing</SortableHeaderComponent>,
            width: 80,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'accessTicketGroupName',
            field: 'accessTicketGroupName',
            headerName: 'Ticket Group',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Ticket<br />Group</SortableHeaderComponent>,
            width: 100
        },

        {
            colId: 'changeUsername',
            field: 'changeUsername',
            headerName: 'Change Username',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Change<br />Username</SortableHeaderComponent>,
            width: 85,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'changePassword',
            field: 'changePassword',
            headerName: 'Change Password',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Change<br />Password</SortableHeaderComponent>,
            width: 85,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'editProfile',
            field: 'editProfile',
            headerName: 'Edit Profile',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Edit<br />Profile</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'isCenter',
            field: 'isCenter',
            headerName: 'Center',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'addCenterUser',
            field: 'addCenterUser',
            headerName: 'Add Center User',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Add<br />Center User</SortableHeaderComponent>,
            width: 95,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'isLogisticsProvider',
            field: 'isLogisticsProvider',
            headerName: 'Logistics Provider',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Logistics<br />Provider</SortableHeaderComponent>,
            width: 80,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'isXmKitVendor',
            field: 'isXmKitVendor',
            headerName: 'XM Kit Vendor',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>XM Kit<br />Vendor</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'isSerologyVendor',
            field: 'isSerologyVendor',
            headerName: 'Serology Vendor',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Serology<br />Vendor</SortableHeaderComponent>,
            width: 80,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'isRecipient',
            field: 'isRecipient',
            headerName: 'Recipient',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Recipient</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'isDonor',
            field: 'isDonor',
            headerName: 'Donor',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Donor</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'isPhlebot',
            field: 'isPhlebot',
            headerName: 'Phlebot',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Phlebot</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'isNkrLab',
            field: 'isNkrLab',
            headerName: 'NKR Lab',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>NKR Lab</SortableHeaderComponent>,
            width: 75,
            cellRendererFramework: (params: ICellRendererParams) => params.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            colId: 'action',
            field: 'id',
            headerName: '',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}></SortableHeaderComponent>,
            width: 75,
            cellClass: 'action-menu',
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IGroup;

                // return (
                //     <DropdownButton bsStyle='primary' bsSize='xs' pullRight title='Actions' id={'actions-' + data.id} onSelect={(e: any) => this.handleAction(data.id, e)}>
                //         <MenuItem eventKey={'EDIT'}>Edit</MenuItem>
                //         <MenuItem eventKey={'DELETE'}>Delete</MenuItem>
                //     </DropdownButton>
                // );

                return <Button bsStyle='primary' bsSize='xs' block onClick={() => props.onEdit(data.id)}>Edit</Button>
            }
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <GridWrapper className='ag-theme-bootstrap' style={{ height: '77vh' }}>
            <AgGridReact
                defaultColDef={{
                    headerClass: 'list-header',
                    cellClass: 'list-cell',
                    sortable: true,
                    resizable: false
                }}
                columnDefs={columnDefs}
                rowData={rowData}
                headerHeight={45}
                rowHeight={30}
                suppressRowClickSelection={false}
                suppressCellSelection={true}
                noRowsOverlayComponentFramework={() => <div>No groups found...</div>}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
            />
        </GridWrapper>
    );
}

export default GroupGrid;